'use client'
import { ItemImageCarousel } from '@/app/ui/parts/default/sp/item/itemImageCarousel'
import { AddCartForm } from '@/app/ui/parts/default/sp/parts/addCartForm'
import { singleItemResponseType } from '@/lib/item/server'
import { serviceType } from '@/lib/service/server'
import { Fragment } from 'react'

type ItemMainInfoProps = {
  item: singleItemResponseType
  service: serviceType
  liked: boolean
}

export const ItemMainInfoWithDescription: React.FC<ItemMainInfoProps> = ({
  service,
  item,
  liked,
}) => {
  return (
    <Fragment>
      <ItemImageCarousel
        images={item.item_images}
        item_id={item.item.item_id}
        service_id={service.service_id}
        liked={liked}
        like_count={item.item.like_count}
        one_day_sale={item.item.one_day_sale}
        campaigns={item.campaigns}
        name={item.item.name}
      />
      <div className="item-main-info p-4 text-left">
        <h1 className="text-[15px] font-semibold" style={{ color: '#424242' }}>
          {item.item.name}
        </h1>
        <div className="item-description text-sm mt-2 text-[#424242]">
          <p>{item.item.description}</p>
        </div>
      </div>
      <AddCartForm
        service={service}
        item={item.item}
        itemOptions={item.item_options.filter((o) => o.stock == true)}
      />
    </Fragment>
  )
}
